import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { FormPayload } from '@dev/ee-api/ee-api-models';
import { HideDialog } from '@/store/dialog/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import { TemplateFormPayloadUpdate, TemplateIncrementAutosaveCounter } from '@/store/paidNewsletterCreator/actions';
import { FormMultiDoubleOptInCustomizeModalBody } from './components/FormMultiDoubleOptInCustomizeModalBody';
import { FormMultiDoubleOptInCustomizeModalProps } from './types';


export const useFormMultiDoubleOptInCustomizeModalParams = ({ historyBackAction }: FormMultiDoubleOptInCustomizeModalProps): {
    getFormMultiDoubleOptInCustomizeModalParams: (blockClientId: string, templateFormPayload?: FormPayload) => ShowDialogParams;
} => {
    const dispatch = useDispatch<any>();
    const { t } = useTranslation();
    const newFormPayloadSaveRef = useRef<Partial<FormPayload> | null>(null);    
    const onClose = (): void => {
        historyBackAction?.popBackCallback();
    };

    const updateFormPayload = (formPayload: Partial<FormPayload>): void => {
        newFormPayloadSaveRef.current = formPayload;
    };

    const getFormMultiDoubleOptInCustomizeModalParams = (blockClientId: string, templateFormPayload?: FormPayload): ShowDialogParams => {
        const onSaveClick = (): void => {
            if (!newFormPayloadSaveRef.current) {
                return;
            }
            const formPayload = newFormPayloadSaveRef.current;
            dispatch(TemplateFormPayloadUpdate(blockClientId, formPayload));
            dispatch(TemplateIncrementAutosaveCounter());
            dispatch(HideDialog());
        };

        return {
            title: t('doubleoptinsettings'),
            confirmLabel: t('save'),
            onClickConfirm: onSaveClick,
            cancelLabel: t('cancel'),
            onClickCancel: onClose,
            isDisabled: false,
            body: <FormMultiDoubleOptInCustomizeModalBody updateFormPayload={updateFormPayload} templateFormPayload={templateFormPayload} historyBackAction={historyBackAction} />,
            id: 'doubleoptinsettings-modal',
            width: '754px',
            isHiddenManually: true,
        };
    };
    return { getFormMultiDoubleOptInCustomizeModalParams };
};
